import * as React from "react";
import { forwardRef } from "react";
const SvgPharmaSpectra = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlnsXlink: "http://www.w3.org/1999/xlink", "data-testid": "brand-logo", viewBox: "0 0 37 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "styles__StyledBrandLogoIcon-sc-1x85kcs-0 itRlSw", width: 20, height: 20, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4633 0L24.3705 10.3867L4.94662 22.9271L18.4633 0ZM36.8043 32H0L3.46434 25.7789L31.0087 21.3384L36.8043 32Z", fill: "#D090C2" }));
const ForwardRef = forwardRef(SvgPharmaSpectra);
export { ForwardRef as ReactComponent };
